module.exports = __webpack_public_path__ + "static/media/18-1.f765179e.mp3";